<template>
    <div class="ma-0 pa-0">
        <v-app-bar app color="primary" dark elevation="0" height="64">
            <DialogoFotos ref="dialFotos" :titulo="titulo" :tipo="tipo" :width="ancho" />
            <DialogoCard ref="refDialogo" :titulo="titulo" :tipo="tipo" :width="ancho" />
            <v-container fluid class="ma-0 pa-0">
                <v-row align="center" no-gutters>
                    <!-- Logo a la izquierda -->
                    <v-col cols="auto">
                        <v-img :src="require('@/assets/Logo-white.png')" max-width="180" max-height="50" contain
                            class="ml-2" />
                    </v-col>
                    <v-spacer></v-spacer>
                    <!-- Icono de menú a la derecha -->
                    <v-col cols="auto">
                        <v-btn icon @click="drawer = !drawer" class="mr-2">
                            <v-icon>{{ drawer ? 'mdi-close' : 'mdi-menu' }}</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-app-bar>

        <!-- Menu Fullscreen -->
        <v-card>
            <v-expand-transition>

                <v-sheet v-show="drawer" class="ma-0 pa-0 fullscreen-menu" color="white">
                    <v-container fluid class="ma-0 pa-0 fill-height">
                        <v-row no-gutters class="fill-height">
                            <v-col cols="12">
                                <v-card flat class="rounded-0">
                                    <!-- Foto y datos del usuario -->
                                    <v-row align="center" class="pa-4">
                                        <!-- Foto de perfil a la izquierda -->
                                        <v-col cols="auto">
                                            <a @click="lanzarDialogFoto" class="position-relative d-inline-block">
                                                <v-btn absolute
                                                    style="position:absolute;bottom:0px;left: 56px; top: 65px;" fab
                                                    x-small color="primary">
                                                    <v-icon>mdi-camera-plus-outline</v-icon>
                                                </v-btn>
                                                <v-avatar size="60">
                                                    <v-img v-if="user.fotoperfil"
                                                        :src="`data:image/png;base64,${user.fotoperfil}`" />
                                                    <v-img v-else src="@/assets/img-user-profile.png" contain />
                                                </v-avatar>
                                            </a>
                                        </v-col>
                                        <!-- Nombre y matrícula a la derecha -->
                                        <v-col class="text-left">
                                            <div class="font-weight-bold black--text text-body-1">
                                                {{ user.nombres }} {{ user.apellido }}
                                            </div>
                                            <div class="font-weight-bold primary--text text-body-2">
                                                Matrícula Nº {{ user.nroafi }}
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <v-divider></v-divider>

                                    <!-- Menú de navegación -->
                                    <v-list dense class="py-0">
                                        <template v-for="(item, index) in menuItems">
                                            <!-- Item con hijos (submenú) -->
                                            <v-list-group v-if="item.children" :key="'group-' + index"
                                                :prepend-icon="item.icon" no-action>
                                                <template v-slot:activator>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </template>

                                                <v-list-item v-for="(child, i) in item.children" :key="i"
                                                    :to="child.route" @click="handleNavigation(child.action)"
                                                    class="pl-8">
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{ child.title }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list-group>

                                            <!-- Item simple (sin hijos) -->
                                            <v-list-item v-else :key="'item-' + index" :to="item.route"
                                                @click="handleNavigation(item.action)">
                                                <v-list-item-icon>
                                                    <v-icon>{{ item.icon }}</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-list>

                                    <v-divider></v-divider>

                                    <!-- Botones de acción -->
                                    <!--                                     <div>
                                        <v-btn class="pa-6 rounded-0" block text @click="lanzarCambiarPass">
                                            <v-icon class="mr-2">mdi-account-key-outline</v-icon>
                                            cambiar contraseña
                                        </v-btn>
                                        <v-btn class="pa-6 rounded-0" text block @click="closeSesion">
                                            <v-icon class="mr-2">mdi-logout</v-icon>
                                            cerrar sesión
                                        </v-btn>
                                    </div> -->
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>
            </v-expand-transition>
        </v-card>
    </div>
</template>
<script>
import DialogoFotos from '@/components/dialogos/DialogoFotos.vue';
import DialogoCard from '@/components/dialogos/DialogoCard.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'NuevoNav',
    components: {
        DialogoFotos,
        DialogoCard
    },
    data() {
        return {
            drawer: false,
            titulo: '',
            ancho: '',
            tipo: ''
        }
    },
    computed: {
        ...mapGetters('auth', ['user']),
        ...mapGetters('navigations', { menuItems: 'items' })
    },
    methods: {
        ...mapActions('auth', ['cerrarSesion']),
        ...mapActions('notificaciones', ['startLoading']),

        lanzarDialogFoto() {
            this.titulo = 'Foto de perfil'
            this.tipo = "fotoperfil"
            this.ancho = 500
            this.$refs.dialFotos.abrirDialogo()
        },
        lanzarCambiarPass() {
            this.drawer = false;
            this.titulo = 'Cambio de contraseña'
            this.ancho = 700
            this.tipo = 'pass'
            this.$refs.refDialogo.abrirDialogo()
        },
        closeSesion() {
            this.drawer = false;
            this.startLoading()
            this.cerrarSesion()
        },
        handleNavigation(action) {
            // Cerrar el menú
            this.drawer = false;

            // Si hay una acción especial, ejecutarla
            if (action) {
                this.handleAction(action);
            }
        },
        handleAction(action) {
            if (!action) return;

            // Manejar acciones especiales como credenciales
            if (action === 'credencialAfiliado') {
                // Implementar lógica para credencial de afiliado
                console.log('Abrir credencial de afiliado');
            } else if (action === 'constanciaConvenios') {
                // Implementar lógica para constancia de convenios
                console.log('Abrir constancia de convenios');
            } else if (action === 'credencialJubilado') {
                // Implementar lógica para credencial de jubilado
                console.log('Abrir credencial de jubilado');
            }
        }
    }
}
</script>

<style scoped>
.v-app-bar {
    z-index: 10;
}

.fullscreen-menu {
    position: fixed;
    top: 64px;
    /* Altura del app-bar */
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    overflow-y: auto;
    height: calc(100vh - 64px);
    margin-top: 0 !important;
    padding-top: 0 !important;
}
</style>
